(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(54788);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CategoryNavigation_CategoryNavigation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ui/links/CustomA.tsx
var CustomA = __webpack_require__(70378);
;// CONCATENATED MODULE: ./components/shop/CategoryNavigation/CategoryNavigationItem.tsx








var CategoryNavigationItem = function(param) {
    var _category = param.category, slug = _category.slug, name = _category.name, url = _category.smallImage.url, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/shop/".concat(slug, "#product-list"),
        passHref: true,
        scroll: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomA/* default */.Z, {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: url,
                        quality: 75,
                        width: 133,
                        height: 133
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: classnames_default()(classes.text, isSelected && classes.textSelected),
                    variant: "h6",
                    component: "h2",
                    children: name
                })
            ]
        })
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            display: "flex",
            flexDirection: "column"
        },
        text: (0,_define_property/* default */.Z)({
            fontWeight: 400,
            fontSize: "0.85rem",
            textAlign: "center"
        }, "&:hover", {
            textDecoration: "underline"
        }),
        textSelected: {
            fontWeight: 700,
            color: theme.palette.primary.main
        }
    };
});
/* harmony default export */ var CategoryNavigation_CategoryNavigationItem = (CategoryNavigationItem);

;// CONCATENATED MODULE: ./components/shop/CategoryNavigation/CategoryNavigation.tsx





var CategoryNavigation = function(param) {
    var categories = param.categories, _categorySlug = param.categorySlug, categorySlug = _categorySlug === void 0 ? "" : _categorySlug;
    var classes = CategoryNavigation_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.grid,
            children: categories.map(function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryNavigation_CategoryNavigationItem, {
                    category: category,
                    isSelected: categorySlug === category.slug
                }, category.sys.id);
            })
        })
    });
};
var CategoryNavigation_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            marginBottom: theme.spacing(6)
        },
        grid: (0,_define_property/* default */.Z)({
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))"
        }, theme.breakpoints.up("sm"), {
            gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))",
            gap: 4
        })
    };
});
/* harmony default export */ var CategoryNavigation_CategoryNavigation = (CategoryNavigation);


/***/ }),

/***/ 54788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ui/Carousel/Carousel.tsx
var Carousel = __webpack_require__(23818);
// EXTERNAL MODULE: ./theme/palette.ts
var palette = __webpack_require__(46054);
;// CONCATENATED MODULE: ./components/home/FeedbacksPreview/FeedbacksPreview.tsx








var MAX_SLIDES_TO_SHOW = 4;
var FeedbacksPreview = function(param) {
    var feedbacks = param.feedbacks;
    var classes = useStyles();
    var ref = (0,useTheme/* default */.Z)(), _breakpoints = ref.breakpoints, breakpoints = _breakpoints.values;
    var autoplay = feedbacks.length > MAX_SLIDES_TO_SHOW;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    arrows: true,
                    infinite: autoplay,
                    autoplay: autoplay,
                    autoplaySpeed: 5000,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    responsive: [
                        {
                            breakpoint: breakpoints.sm,
                            settings: {
                                slidesToShow: 1
                            }
                        },
                        {
                            breakpoint: breakpoints.md,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: breakpoints.lg,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 10000,
                            settings: {
                                slidesToShow: MAX_SLIDES_TO_SHOW
                            }
                        }
                    ],
                    className: classes.container
                },
                children: feedbacks.map(function(param) {
                    var sys = param.sys, image = param.image;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classes.imageContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image.url,
                            layout: "responsive",
                            width: image.width,
                            height: image.height,
                            quality: 75,
                            alt: "Відгук покупця"
                        })
                    }, sys.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.seeAllContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/feedbacks",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        component: "a",
                        children: "Всі відгуки"
                    })
                })
            })
        ]
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1;
    return {
        container: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, "& .slick-list", {
            marginLeft: -theme.spacing(1),
            marginRight: -theme.spacing(1)
        }), (0,_define_property/* default */.Z)(_obj1, "& .slick-slide", {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            boxSizing: "border-box"
        }), (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("sm"), (_obj = {}, (0,_define_property/* default */.Z)(_obj, "& .slick-list", {
            marginLeft: -theme.spacing(1.5),
            marginRight: -theme.spacing(1.5)
        }), (0,_define_property/* default */.Z)(_obj, "& .slick-slide", {
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5)
        }), _obj)), _obj1),
        imageContainer: {
            width: "100%",
            borderRadius: 16,
            overflow: "hidden",
            lineHeight: 0,
            backgroundColor: palette/* extraPalette.grey.lightest */.t.grey.lightest
        },
        seeAllContainer: (0,_define_property/* default */.Z)({
            textAlign: "center",
            marginTop: theme.spacing(3)
        }, theme.breakpoints.up("md"), {
            marginTop: theme.spacing(4)
        })
    };
});
/* harmony default export */ var FeedbacksPreview_FeedbacksPreview = (FeedbacksPreview);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Link/Link.js
var Link = __webpack_require__(89659);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/home/HeroSlider/HeroSliderItem/TextContent.tsx




var TextContent = function(param) {
    var title = param.title, subtitle = param.subtitle;
    var classes = TextContent_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h1",
                className: classes.title,
                children: title
            }),
            !!subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                className: classes.subtitle,
                children: subtitle
            })
        ]
    });
};
var TextContent_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1;
    return {
        title: (_obj = {
            color: theme.palette.common.white,
            textTransform: "uppercase",
            fontSize: "1.5rem"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            fontSize: "2rem"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            fontSize: "2.75rem"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
            fontSize: "3.75rem"
        }), _obj),
        subtitle: (_obj1 = {
            color: theme.palette.common.white,
            fontWeight: 800,
            textTransform: "uppercase",
            fontSize: "1.125rem"
        }, (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("sm"), {
            fontSize: "1.75rem"
        }), (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("md"), {
            fontSize: "2.25rem"
        }), (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("lg"), {
            fontSize: "3rem"
        }), _obj1)
    };
});
/* harmony default export */ var HeroSliderItem_TextContent = (TextContent);

;// CONCATENATED MODULE: ./components/home/HeroSlider/HeroSliderItem/ItemContent.tsx






var ItemContent = function(param) {
    var title = param.title, subtitle = param.subtitle, _textAlign = param.textAlign, textAlign = _textAlign === void 0 ? "center" : _textAlign;
    var classes = ItemContent_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classnames_default()(classes.content),
        style: {
            textAlign: textAlign
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSliderItem_TextContent, {
            title: title,
            subtitle: subtitle
        })
    });
};
var ItemContent_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        content: (_obj = {
            textAlign: "initial",
            padding: 0
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            padding: theme.spacing(1)
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            padding: theme.spacing(2)
        }), _obj),
        linkedContent: {
            textDecoration: "none",
            cursor: "pointer",
            "&:hover": {
                opacity: 0.7,
                transition: "opacity 300ms",
                textDecoration: "none"
            }
        }
    };
});
/* harmony default export */ var HeroSliderItem_ItemContent = (ItemContent);

// EXTERNAL MODULE: ./utils/hooks/useLinkSwipe.ts
var useLinkSwipe = __webpack_require__(41535);
;// CONCATENATED MODULE: ./components/home/HeroSlider/HeroSliderItem/HeroSliderItem.tsx









var LinkComponent = function(param) {
    var children = param.children, link = param.link;
    var ref = (0,useLinkSwipe/* useLinkSwipe */.c)(), handleClick = ref.handleClick, handleMouseDown = ref.handleMouseDown;
    var classes = HeroSliderItem_useStyles();
    if (!link) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            className: classes.linkedContent,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            children: children
        })
    });
};
var HeroSliderItem = function(param) {
    var _item = param.item, image = _item.image, title = _item.title, subtitle = _item.subtitle, _position = _item.position, position = _position === void 0 ? "center" : _position, link = _item.link, textAlign = _item.textAlign, _priority = param.priority, priority = _priority === void 0 ? false : _priority;
    var classes = HeroSliderItem_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent, {
        link: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            component: "article",
            className: classes.container,
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: classnames_default()(classes.contentContainer, classes[position]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSliderItem_ItemContent, {
                        title: title,
                        subtitle: subtitle,
                        textAlign: textAlign
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: classes.imageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image.url,
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "center",
                        quality: 75,
                        priority: priority,
                        sizes: "100vw",
                        alt: title || ""
                    })
                })
            ]
        })
    });
};
var HeroSliderItem_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1;
    return _obj1 = {
        container: (_obj = {
            width: "100%",
            height: "55vw",
            position: "relative"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            height: "48vh"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
            height: "58vh"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xl"), {
            height: "62vh"
        }), _obj),
        imageContainer: {
            position: "absolute",
            top: 0,
            height: "100%",
            width: "100%",
            overflow: "hidden",
            zIndex: -1
        },
        contentContainer: {
            height: "100%",
            display: "flex",
            alignItems: "flex-start",
            padding: theme.spacing(2),
            paddingBottom: theme.spacing(3.5)
        },
        content: {
            textAlign: "initial",
            padding: theme.spacing(2)
        },
        linkedContent: {
            "&:hover": {
                textDecoration: "none"
            },
            "&:hover h1": {
                opacity: 0.7,
                transition: "opacity 300ms",
                textDecoration: "none"
            },
            "&:hover h2": {
                opacity: 0.7,
                transition: "opacity 300ms",
                textDecoration: "none"
            }
        }
    }, (0,_define_property/* default */.Z)(_obj1, "top-left", {
        justifyContent: "flex-start"
    }), (0,_define_property/* default */.Z)(_obj1, "top-center", {
        justifyContent: "center"
    }), (0,_define_property/* default */.Z)(_obj1, "top-right", {
        justifyContent: "flex-end"
    }), (0,_define_property/* default */.Z)(_obj1, "center-left", {
        alignItems: "center"
    }), (0,_define_property/* default */.Z)(_obj1, "center", {
        alignItems: "center",
        justifyContent: "center"
    }), (0,_define_property/* default */.Z)(_obj1, "center-right", {
        alignItems: "center",
        justifyContent: "flex-end"
    }), (0,_define_property/* default */.Z)(_obj1, "bottom-left", {
        alignItems: "flex-end"
    }), (0,_define_property/* default */.Z)(_obj1, "bottom-center", {
        justifyContent: "center"
    }), (0,_define_property/* default */.Z)(_obj1, "bottom-right", {
        alignItems: "flex-end",
        justifyContent: "flex-end"
    }), _obj1;
});
/* harmony default export */ var HeroSliderItem_HeroSliderItem = (HeroSliderItem);

;// CONCATENATED MODULE: ./components/home/HeroSlider/HeroSlider.tsx





var HeroSlider = function(param) {
    var heroSlides = param.heroSlides;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mb: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5000,
                dots: true
            },
            children: heroSlides.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSliderItem_HeroSliderItem, {
                    item: item,
                    priority: index === 0
                }, item.sys.id);
            })
        })
    });
};
/* harmony default export */ var HeroSlider_HeroSlider = (HeroSlider);

// EXTERNAL MODULE: ./components/layout/Layout.tsx + 13 modules
var Layout = __webpack_require__(78690);
// EXTERNAL MODULE: ./components/product/FeaturedProducts/FeaturedProducts.tsx + 1 modules
var FeaturedProducts = __webpack_require__(63189);
// EXTERNAL MODULE: ./components/ui/links/CustomA.tsx
var CustomA = __webpack_require__(70378);
;// CONCATENATED MODULE: ./components/home/CategoryTiles/CategoryTileItem.tsx








var CategoryTileItem = function(param) {
    var _category = param.category, url = _category.image.url, name = _category.name, slug = _category.slug;
    var classes = CategoryTileItem_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            pathname: "/shop/".concat(slug),
            hash: "product-list"
        },
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.container,
                component: "article",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: url,
                        quality: 75,
                        width: 390,
                        height: 390
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classnames_default()(classes.titleContainer, "category-tile-title"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            component: "h3",
                            className: classes.title,
                            children: name
                        })
                    })
                ]
            })
        })
    });
};
var CategoryTileItem_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            width: "100%",
            cursor: "pointer",
            position: "relative",
            "&:hover .category-tile-title": {
                backgroundColor: "transparent"
            },
            "&:hover .category-tile-title h3": {
                color: theme.palette.common.white,
                fontWeight: 600
            }
        },
        titleContainer: (0,_define_property/* default */.Z)({
            position: "absolute",
            left: "50%",
            transform: "translate(-50%, 0)",
            bottom: theme.spacing(6),
            minWidth: "70%",
            backgroundColor: theme.palette.common.white,
            borderStyle: "solid",
            borderWidth: 2,
            borderColor: theme.palette.common.white,
            textAlign: "center",
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            transition: "background-color 300ms",
            paddingLeft: theme.spacing(0.5),
            paddingRight: theme.spacing(0.5)
        }, theme.breakpoints.up("sm"), {
            whiteSpace: "nowrap"
        }),
        title: (0,_define_property/* default */.Z)({
            textTransform: "uppercase",
            transition: "color 300ms",
            fontWeight: 400,
            fontSize: "0.875rem"
        }, theme.breakpoints.up("sm"), {
            fontSize: "1.25rem"
        })
    };
});
/* harmony default export */ var CategoryTiles_CategoryTileItem = (CategoryTileItem);

;// CONCATENATED MODULE: ./components/home/CategoryTiles/CategoryTiles.tsx





var CategoryTiles = function(param) {
    var categories = param.categories;
    var classes = CategoryTiles_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classes.container,
        children: categories.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTiles_CategoryTileItem, {
                category: category
            }, category.sys.id);
        })
    });
};
var CategoryTiles_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        container: (_obj = {
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "".concat(theme.spacing(0.5), "px ").concat(theme.spacing(0.5), "px")
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            gap: "".concat(theme.spacing(4), "px ").concat(theme.spacing(4), "px")
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            gridTemplateColumns: "1fr 1fr 1fr"
        }), _obj)
    };
});
/* harmony default export */ var CategoryTiles_CategoryTiles = (CategoryTiles);

// EXTERNAL MODULE: ./components/shop/CategoryNavigation/CategoryNavigation.tsx + 1 modules
var CategoryNavigation = __webpack_require__(45243);
;// CONCATENATED MODULE: ./components/home/HomeBlock.tsx





var HomeBlock = function(param) {
    var title = param.title, children = param.children, _dense = param.dense, dense = _dense === void 0 ? false : _dense, _tightBottom = param.tightBottom, tightBottom = _tightBottom === void 0 ? false : _tightBottom;
    var classes = HomeBlock_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: classnames_default()(classes.container, tightBottom && classes.tightBottom),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                textAlign: "center",
                className: classnames_default()(classes.titleContainer, dense && classes.denceTitleContainer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    className: classes.title,
                    children: title
                })
            }),
            children
        ]
    });
};
var HomeBlock_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: (0,_define_property/* default */.Z)({
            marginBottom: theme.spacing(8)
        }, theme.breakpoints.up("md"), {
            marginBottom: theme.spacing(17)
        }),
        tightBottom: (0,_define_property/* default */.Z)({
            marginBottom: theme.spacing(4)
        }, theme.breakpoints.up("md"), {
            marginBottom: theme.spacing(8)
        }),
        titleContainer: (0,_define_property/* default */.Z)({
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            marginBottom: theme.spacing(5.5)
        }),
        denceTitleContainer: (0,_define_property/* default */.Z)({
            marginBottom: theme.spacing(1)
        }, theme.breakpoints.up("md"), {
            marginBottom: theme.spacing(2.5)
        }),
        title: (0,_define_property/* default */.Z)({
            textTransform: "uppercase",
            fontSize: "1.5rem"
        }, theme.breakpoints.up("md"), {
            fontSize: "1.875rem"
        })
    };
});
/* harmony default export */ var home_HomeBlock = (HomeBlock);

// EXTERNAL MODULE: ./components/home/Features/Features.tsx + 5 modules
var Features = __webpack_require__(86821);
// EXTERNAL MODULE: ./components/layout/JsonLd.tsx
var JsonLd = __webpack_require__(49946);
// EXTERNAL MODULE: ./domain/constants/index.ts + 7 modules
var constants = __webpack_require__(74692);
// EXTERNAL MODULE: ./domain/constants/CONTACTS.ts
var CONTACTS = __webpack_require__(59919);
;// CONCATENATED MODULE: ./pages/index.tsx














var Home = function(param) {
    var heroSlides = param.heroSlides, featuredProducts = param.featuredProducts, bestsellers = param.bestsellers, categories = param.categories, feedbacks = param.feedbacks, pageMeta = param.pageMeta;
    var classes = pages_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageMeta: pageMeta,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
                keyName: "organization-jsonld",
                data: {
                    "@context": "https://schema.org",
                    "@type": "OnlineStore",
                    name: constants/* DEFAULT_META_DATA.title */.ql.title,
                    description: constants/* DEFAULT_META_DATA.description */.ql.description,
                    url: constants/* APP_URL */.FX,
                    logo: "".concat(constants/* APP_URL */.FX, "/logo.png"),
                    email: CONTACTS/* CONTACTS.email */.r.email,
                    telephone: CONTACTS/* CONTACTS.phoneNumber */.r.phoneNumber,
                    sameAs: [
                        CONTACTS/* CONTACTS.instagramUrl */.r.instagramUrl
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSlider_HeroSlider, {
                heroSlides: heroSlides
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.categoryNavigation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryNavigation/* default */.Z, {
                    categories: categories
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeBlock, {
                        title: "Новинки",
                        dense: true,
                        tightBottom: bestsellers.length > 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProducts/* default */.Z, {
                            products: featuredProducts,
                            size: "small"
                        })
                    }),
                    bestsellers.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeBlock, {
                        title: "Хіти продажів",
                        dense: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProducts/* default */.Z, {
                            products: bestsellers,
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeBlock, {
                        title: "Магазин",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTiles_CategoryTiles, {
                            categories: categories
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Features/* default */.Z, {}),
                    feedbacks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeBlock, {
                        title: "Відгуки",
                        dense: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbacksPreview_FeedbacksPreview, {
                            feedbacks: feedbacks
                        })
                    })
                ]
            })
        ]
    });
};
var pages_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        categoryNavigation: (0,_define_property/* default */.Z)({
            display: "none"
        }, theme.breakpoints.up("md"), {
            display: "block"
        })
    };
});
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,351,39,690,593,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);